// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__e0tWc","title":"Sidebar_title__or6cP","list":"Sidebar_list__xS6Af","active":"Sidebar_active__vFX0A","list_item":"Sidebar_list_item__UnT0Q"};